'use client';

import { type AbstractIntlMessages, NextIntlClientProvider } from 'next-intl';

import type { Locale } from '@/lib/constants';

/**
 * An intl provider fed only by props. The server-side `NextIntlClientProvider` fills
 * every prop it is not given from the request config, which reads the request locale;
 * a document that must not touch request state (the root 404, prerendered next to
 * every public page) passes its locale and messages here instead. The fixed time zone
 * only stops use-intl's environment-fallback warning; the 404 renders no date.
 */
export function StaticIntlProvider({
  locale,
  messages,
  children,
}: {
  locale: Locale;
  messages: AbstractIntlMessages;
  children: React.ReactNode;
}) {
  return (
    <NextIntlClientProvider locale={locale} messages={messages} timeZone="UTC">
      {children}
    </NextIntlClientProvider>
  );
}
